import { gql } from '__generated__';

export default gql(`
  mutation EnableMolliePaymentMethod($input: ToggleMolliePaymentMethodInput!) {
    enableMolliePaymentMethod(input: $input) {
      success
      continue_url
      payment_method {
        id
        enabled
      }
    }
  }
`);
